/* Yaniko — Конфигуратор за гривни · сметачна част
   Портната логика от konec.bg (App\Livewire\SimpleBraceletBuilder).
   Всяко число тук трябва да съвпада с PHP-то до стотинка — виж parity теста.
   Държи се отделно от интерфейса, за да може да се тества без браузър. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.YGKEngine = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var SIZES = [2, 2.5, 3, 4, 5, 6];

  /* Ползваема дължина (мм) според размера на топчето. Нагодена по реални
     мостри: 10 златни топчета дават 45/33/29/25/21 камъка за 2/3/4/5/6мм. */
  function braceletLength(beadSize) {
    if (beadSize <= 2) return 110;
    if (beadSize <= 2.5) return 120;
    if (beadSize <= 3) return 129;
    if (beadSize <= 4) return 156;
    if (beadSize <= 5) return 175;
    return 186;
  }

  /* Най-много злато, което се побира: до 60% от дължината, за да остане
     място за камъни. Дължината се води по камъка, защото той доминира. */
  function maxGoldCount(goldSize, gemSize) {
    if (!goldSize) return 0;
    var effective = gemSize || goldSize;
    var maxGoldSpace = braceletLength(effective) * 0.6;
    return Math.max(1, Math.floor(maxGoldSpace / goldSize));
  }

  /* Колко камъка се побират в останалото място. */
  function gemCount(goldSize, goldCount, gemSize) {
    if (!goldSize || goldCount === 0) return 0;
    var effective = gemSize || goldSize;
    var remaining = braceletLength(effective) - goldCount * goldSize;
    if (remaining <= 0) return 0;
    return Math.floor(remaining / effective);
  }

  /* Подредбата: златото е събрано в средата (срещу възела), между всеки две
     златни топчета има камък-разделител, останалите камъни се делят от двете
     страни. Нечетният остатък отива след златото — както в PHP-то. */
  function computeLayout(goldSize, goldCount, gemSize) {
    if (!goldSize || goldCount === 0) return [];

    var effective = gemSize || goldSize;
    var total = gemCount(goldSize, goldCount, gemSize);
    if (total < 0) return [];

    var spacers = Math.max(0, goldCount - 1);
    var rest = Math.max(0, total - spacers);
    var before = Math.floor(rest / 2);
    var after = rest - before;

    var layout = [];
    var i;
    for (i = 0; i < before; i++) layout.push({ type: 'gem', size: effective });
    for (i = 0; i < goldCount; i++) {
      layout.push({ type: 'gold', size: goldSize });
      if (i < goldCount - 1) layout.push({ type: 'gem', size: effective });
    }
    for (i = 0; i < after; i++) layout.push({ type: 'gem', size: effective });

    return layout;
  }

  /* цена = злато × цена за размера + камъни × цена на камъка. Конецът е безплатен.
     Камъните се броят от подредбата, не от gemCount — разделителите също се плащат. */
  function price(cfg) {
    var total = 0;
    var goldPrice = cfg.goldPrices[String(cfg.goldSize)];
    total += cfg.goldCount * (goldPrice || 0);

    if (cfg.gem) {
      var layout = computeLayout(cfg.goldSize, cfg.goldCount, cfg.gemSize);
      var stones = layout.filter(function (b) { return b.type === 'gem'; }).length;
      total += stones * cfg.gem.price;
    }

    return total;
  }

  /* ===================== ПРО КОНФИГУРАТОР (топче по топче) =====================
     Втори модел, портнат от App\Livewire\BraceletBuilder. Тук няма решаване на
     подредба — клиентът реди сам. Нишката е 34см, от които 18см (180мм) се
     нижат; останалото са възелът и краищата. */

  var PRO_USABLE_MM = 180;

  /* Всяка позиция е или златно топче {type:'gold', size}, или камък
     {type:'gem', id, size}. Заетото място е просто сборът от диаметрите. */
  function usedSpace(positions) {
    var total = 0;
    for (var i = 0; i < positions.length; i++) {
      total += positions[i].size || 0;
    }
    return Math.round(total * 100) / 100;
  }

  function freeSpace(positions) {
    return Math.round((PRO_USABLE_MM - usedSpace(positions)) * 100) / 100;
  }

  /* Побира ли се още едно топче? При симетрия трябва двойно място, защото
     топчето отива и в двата края наведнъж. */
  function fits(positions, size, symmetry) {
    return freeSpace(positions) >= (symmetry ? size * 2 : size);
  }

  /* Връща НОВ списък — състоянието не се пипа на място, за да може „назад"
     да пази предишните списъци без изненади. */
  function addBead(positions, bead, symmetry) {
    if (!fits(positions, bead.size, symmetry)) return null;
    var next = positions.slice();
    if (symmetry) {
      next.unshift(bead);
      next.push(bead);
    } else {
      next.push(bead);
    }
    return next;
  }

  function removeAt(positions, index) {
    if (index < 0 || index >= positions.length) return positions;
    var next = positions.slice();
    next.splice(index, 1);
    return next;
  }

  function proPrice(positions, goldPrices, gemsById) {
    var total = 0;
    for (var i = 0; i < positions.length; i++) {
      var b = positions[i];
      if (b.type === 'gold') {
        total += goldPrices[String(b.size)] || 0;
      } else {
        var gem = gemsById[String(b.id)];
        if (gem) total += gem.price;
      }
    }
    return total;
  }

  return {
    SIZES: SIZES,
    braceletLength: braceletLength,
    maxGoldCount: maxGoldCount,
    gemCount: gemCount,
    computeLayout: computeLayout,
    price: price,

    PRO_USABLE_MM: PRO_USABLE_MM,
    usedSpace: usedSpace,
    freeSpace: freeSpace,
    fits: fits,
    addBead: addBead,
    removeAt: removeAt,
    proPrice: proPrice
  };
}));
